import { defineStore } from 'pinia'
import { migrateFilter, FILTER_VERSION } from '@/components/timinplanner/resourceFilter'

export const useViewStore = defineStore('view', {
  state: () => ({
    actionView: 'planner',  // Default view
	username: '',
	countActiveUsers: 0,
	openProjects: [],
	allBookings: true,
	activeProjects: true,
	plannedProjects: false,
	printTimeStart: null,
	printTimeEnd: null,
	zoomVal: null,
	zoomStart: null,
	zoomEnd: null,
	zoomWidthPerDay: null,
	resourceFilters: {},
  }),
  actions: {
	isZoom() {
        return this.zoomWidthPerDay !== null;
	},
    setActionView(view) {
      this.actionView = view
    },
	setUsername(username) {
	  this.username = username
	},
	setCountActiveUsers(countActiveUsers) {
	  this.countActiveUsers = countActiveUsers
	},
    toggleProject(pid) {
      if (this.openProjects.includes(pid)) {
        this.openProjects = this.openProjects.filter(el => el !== pid);
      } else {
        this.openProjects.push(pid);
      }
	},
	isOpenProject(pid) {
		return this.openProjects.includes(pid);
	},
	setProjectFilter(all, active, planned) {
	  console.log("setProjectFilter all=" + all + " active=" + active + " planned=" + planned)
	  this.allBookings = all;
	  this.activeProjects = active;
	  this.plannedProjects = planned;
	},
	showAllBookings() {
	  return this.allBookings; 
	},
	showActiveProjects() {
	  return this.activeProjects;
	},
	showPlannedProjects() {
	  return this.plannedProjects;
	},
	// Die Filter liegen persistiert im Browser und stammen teils noch aus dem
	// alten Format; migrateFilter faengt das ab und faellt im Zweifel auf den
	// Standard zurueck.
	//
	// Bewusst OHNE Seiteneffekt: der Getter laeuft aus einem computed heraus, und
	// ein Schreibzugriff darin wuerde den Store veraendern, das computed erneut
	// ausloesen und sich im Kreis drehen. Umgeschrieben wird erst beim Speichern.
	getResourceFilter(pid) {
	  const raw = this.resourceFilters[pid];
	  return raw != null && raw.v === FILTER_VERSION ? raw : migrateFilter(raw);
	},
	setResourceFilter(pid, filter) {
	  this.resourceFilters[pid] = migrateFilter(filter);
	},
	// Personenfilter liegen je Projekt-ID im localStorage und ueberleben das
	// Projekt: wird eines geloescht, bleibt sein Filter fuer immer liegen. Legt
	// die Datenbank spaeter dieselbe ID neu an, erbt das neue Projekt einen
	// Filter, den nie jemand dafuer gesetzt hat - der Trichter steht dann grün,
	// ohne dass der Nutzer etwas getan haette.
	//
	// Beim Laden deshalb alles verwerfen, wozu es kein Projekt mehr gibt. Die
	// leere Liste ist ausgenommen: waehrend eines fehlgeschlagenen Ladens
	// wuerden sonst alle Filter auf einen Schlag verschwinden.
	pruneResourceFilters(gueltigeIds) {
	  const ids = new Set((gueltigeIds ?? []).map(id => String(id)));
	  if (ids.size === 0) return 0;

	  const uebrig = {};
	  let entfernt = 0;
	  for (const [pid, filter] of Object.entries(this.resourceFilters)) {
	    if (ids.has(String(pid))) uebrig[pid] = filter;
	    else entfernt += 1;
	  }
	  if (entfernt > 0) this.resourceFilters = uebrig;

	  // openProjects wird ebenfalls gemerkt und sammelt dieselben Karteileichen.
	  const offen = this.openProjects.filter(pid => ids.has(String(pid)));
	  if (offen.length !== this.openProjects.length) {
	    entfernt += this.openProjects.length - offen.length;
	    this.openProjects = offen;
	  }
	  return entfernt;
	},
	setPrintTimeStart(startdate) {
	  this.printTimeStart = startdate;
	},
	setPrintTimeEnd(enddate) {
	  this.printTimeEnd = enddate;
	},
	setZoomVal(zoomVal) {
	  this.zoomVal = zoomVal;
	},
	setZoomStart(zoomStart) {
	  this.zoomStart = zoomStart;
	},
	setZoomEnd(zoomEnd) {
	  this.zoomEnd = zoomEnd;
	},
	setZoomWidthPerDay(width) {
	  this.zoomWidthPerDay = width;
	}
  },
  persist: {
    // openProjects gehoert dazu: welche Projekte aufgeklappt sind, soll ein
    // Neuladen ueberstehen (TIM-73, Schritt 3). Verwaiste IDs raeumt
    // pruneResourceFilters mit weg.
    pick: ['actionView', 'openProjects', 'allBookings', 'activeProjects', 'plannedProjects', 'printTimeStart', 'printTimeEnd', 'zoomVal', 'zoomStart', 'zoomEnd', 'zoomWidthPerDay', 'resourceFilters'],
  },
})
